import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./nav-menu.css";
import { Link } from "react-router-dom";
import portalLogo from "../../assets/images/portal-logo.png";
import NotifyLogo from "../../assets/images/notify-logo.png";
import DefaultSupport from "../account/Support";
import VideoModal from "../tutorials/VideoModal";
import useUserStore from "../../utils/storeApp";
import $ from "jquery";
import { usePortalAuthentication } from "../../services/authorizationService";
import { getDomainFromUrl } from "../../utils/domainUtilities";
import CallAPI from "../../services/apiCalls";
// Temporarily hidden until GCP side is ready. Revert this line to re-enable.
// import BackendToggle from "./BackendToggle";

const NavMenu = () => {
  const navigate = useNavigate();
  const [flag, setFlag] = useState(false);
  const {
    userRole,
    setSearchObj,
    SetSharedObject,
    userSession,
    userToken,
    sharedObject,
    backendTarget,
  } = useUserStore((state) => ({
    userRole: state.userRole,
    setSearchObj: state.setSearchObj,
    SetSharedObject: state.SetSharedObject,
    userSession: state.userSession,
    userToken: state.userToken,
    sharedObject: state.sharedObject,
    backendTarget: state.backendTarget,
  }));
  const [SupportComponent, setSupportComponent] = useState(() => DefaultSupport);
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [tutorialVideoUrl, setTutorialVideoUrl] = useState("");
  const [processing, SetProcessing] = useState(false);
  const [successFlag, setSuccessFlag] = useState(false);
  const [errMsg, setErrMsg] = useState(
    "Email purpose cannot be updated at this time. Please contact customer support for further assistance."
  );
  const userNameDisplay = userSession.preferred_username?.split("|")[0];
  const { logout } = usePortalAuthentication();

  useEffect(() => {
    if (flag) navigate(flag, { replace: true });
  }, [flag, navigate]);

  useEffect(() => {
    const loadPortalSupport = async () => {
      try {
        const module = await import(
          "../../custom_portal/" + getDomainFromUrl(window.location.hostname) + "/components/account/Support"
        );
        setSupportComponent(() => module.default);
      } catch {
        setSupportComponent(() => DefaultSupport);
      }
    };
    loadPortalSupport();
  }, []);

  const messageStatus = async () => {
    setFlag("/message-status");
  };

  const handleWebmailTutorial = async () => {
    try {
      const res = await CallAPI(
        `/videos/link?videoKey=${encodeURIComponent("media/Webmail.mp4")}`,
        false,
        "get",
        userToken
      );
      const url = res?.data?.url ?? res?.data ?? "";
      if (url) {
        setTutorialVideoUrl(url);
        setVideoModalOpen(true);
      }
    } catch {

    }
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);


  return (
      <nav
          className="navbar navbar-expand-sm navbar-toggleable-sm navbar-light border-bottom  custom-navbar"
          aria-label="Main navigation">
        <div className="container w-max2">
            <img src={portalLogo} alt="" aria-hidden="true" />
            {/* Hamburger Menu*/}
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="navbar-collapse"
              aria-label="Toggle navigation menu"
            >
            <span className="navbar-toggler-icon" aria-hidden="true"></span>
        </button>

        {/* Main Menu Begins */}
        <div 
            className="navbar-collapse collapse d-sm-inline-flex"
            id="navbarMainContent"
        >
          <ul className="navbar-nav flex-grow">
            {userRole !== "SES ADMINISTRATOR" &&
            userRole !== "SYSTEMADMINISTRATOR" &&
            !userSession?.is_gcp_user ? (
              <>
                {sharedObject.getUserEmails &&
                sharedObject.getUserEmails.length > 0 ? (
                  <li className="nav-item">
                    <Link
                      onClick={(el) => {
                        if (window !== "undefined")
                          window.open("../webmail", "_self");
                      }}
                      className="nav-link text-light"
                    >
                      <i
                        className="bi bi-envelope-at-fill sp-margin5 respond-2"
                        aria-hidden="true"
                      ></i>
                      <span className="respond-1">Webmail</span>
                    </Link>
                  </li>
                ) : (
                  <li className="nav-item">
                    <Link
                      to={"/no-direct-email"}
                      className="nav-link text-light"
                    >
                      <i
                        className="bi bi-envelope-at-fill sp-margin5 respond-2"
                        aria-hidden="true"
                      ></i>
                      <span className="respond-1">Webmail</span>
                    </Link>
                  </li>
                )}
              </>
            ) : null}
            {userRole !== "SES ADMINISTRATOR" &&
            userRole !== "SYSTEMADMINISTRATOR" ? (
              <>
                {sharedObject.getUserEmails &&
                sharedObject.getUserEmails.length > 0 ? (
                  <li className="nav-item">
                    <Link
                      onClick={(el) => {
                        SetSharedObject("recievedMessageStatusResults", {});
                        messageStatus(el);
                      }}
                      className="nav-link text-light"
                    >
                      <i
                        className="bi bi-send-check sp-margin5 respond-2"
                        aria-hidden="true"
                      ></i>
                      <span className="respond-1">Message Status</span>
                    </Link>
                  </li>
                ) : null}
              </>
            ) : null}
            <li className="nav-item">
              <Link
                className="nav-link text-light"
                onClick={(el) => {
                  setFlag("/directory-search");
                  SetSharedObject("AdvSearchObj", null);
                }}
              >
                <i
                  className="bi bi-folder sp-margin5 respond-2"
                  aria-hidden="true"
                ></i>
                <span className="respond-1">Directory Search</span>
              </Link>
            </li>
            {userSession.HasNotify === true && userRole === "ADMINISTRATOR" ? (
              <li className="nav-item">
                <Link to="/notify-app" className="nav-link text-light">
                  <img
                    src={NotifyLogo}
                    className="w-s respond-2"
                    alt=""
                  />
                  <span className="respond-1">Notify</span>
                </Link>
              </li>
            ) : null}
          </ul>
        </div>

        {/* User account menu on the right */}
        <div 
            className="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse"
            id="navbarAccountContent"
        >
          <ul className="navbar-nav flex-grow">
            <li className="nav-item dropdown">
              <button
                className="nav-link text-light dropdown-toggle btn btn-link"
                id="accountMenuDropdown"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                aria-label={`Account menu for ${userNameDisplay || "current user"}`}
              >
                <i
                  className="bi bi-person-circle sp-margin5"
                 aria-hidden="true"
                ></i>
                <span className="admin-nav2">{userNameDisplay}</span>
              </button>
              <div
                className="dropdown-menu  shade-1"
                aria-labelledby="accountMenuDropdown"
              >
                <button
                  className="dropdown-item"
                  type="button"
                  aria-haspopup="dialog"
                  onClick={(el) => {
                    setSearchObj([]);
                    SetSharedObject("accountDetailsFlag", true);
                    $("#detailsMemberUserModal").modal("show");
                  }}
                >
                  Account
                </button>

                <Link
                  className="dropdown-item"
                  onClick={(el) => {
                    SetSharedObject("changePasswordFlag", true);
                    SetSharedObject("ResetPasswordId", userSession.sesuser_id);
                    setFlag("/change-password");
                  }}
                >
                  Change Password
                </Link>
              </div>
            </li>
            <li className="nav-item dropdown">
              <button
                className="nav-link text-light dropdown-toggle btn btn-link"
                id="supportMenuDropdown"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="menu"
                aria-expanded="false"
                aria-label="Support menu"
              >
                <i
                  className="bi bi-headset sp-margin5"
                  aria-hidden="true"
                ></i>
                <span className="admin-nav2">Support</span>
              </button>
              <div
                role="menu"
                className="dropdown-menu shade-1"
                aria-labelledby="supportMenuDropdown"
              >
                <button
                  role="menuitem"
                  className="dropdown-item"
                  type="button"
                  aria-haspopup="dialog"
                  data-target="#contactInfoModal"
                  data-toggle="modal"
                >
                  Contact Us
                </button>
                <button
                  role="menuitem"
                  className="dropdown-item"
                  type="button"
                  onClick={handleWebmailTutorial}
                >
                  Webmail Tutorial
                </button>
              </div>
              <SupportComponent />
              <VideoModal
                open={videoModalOpen}
                onClose={() => { setVideoModalOpen(false); setTutorialVideoUrl(""); }}
                videoUrl={tutorialVideoUrl}
              />
            </li>
            {/* Temporarily hidden until GCP side is ready. Revert this line to re-enable.
            {(userRole === "SES ADMINISTRATOR" || userRole === "SYSTEMADMINISTRATOR") && <BackendToggle />} */}
            <li className="nav-item">
              <button
                type="button"
                onClick={(el) => {
                  el.preventDefault();
                  logout();
                }}
                className="nav-link text-light btn btn-link"
              >
                <i
                  className="bi bi-box-arrow-right sp-margin5"
                  aria-hidden="true"
                ></i>
                <span className="admin-nav2">Sign Out</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
      {(userRole === "SES ADMINISTRATOR" || userRole === "SYSTEMADMINISTRATOR") && backendTarget === "gcp" && (
        <div
          role="status"
          aria-live="polite"
          style={{
            background: "#f59e0b",
            color: "#1a1a1a",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "0.8rem",
            padding: "3px 0",
            letterSpacing: "0.05em",
          }}
        >
          ⚠ GCP MODE ACTIVE — ALL API REQUESTS ARE GOING TO GCP BACKEND
        </div>
      )}
      {processing && (
        <div
            className="loader-container"
            role="status"
            aria-live="polite"
            aria-atomic="true"
            aria-labelledby="navmenu-loader-id"
        >
            <div className="spinner" aria-hidden="true"></div>
            <div className="loading-text" id="navmenu-loader-id">{loadingText}</div>
        </div>
      )}
      {successFlag ? (
        <div 
            className="alert alert-danger" 
            role="alert" 
            aria-live="assertive" 
            aria-atomic="true"
         >
          {errMsg}
        </div>
      ) : null}
    </nav>
  );
};
export default NavMenu;
